import type { FC } from 'react';
import { useCallback } from 'react';
import { useGetServiceProviderPhoenix } from '@pflegenavi/service-provider-frontend/api';
import { useKycIdvDialogState } from '@pflegenavi/web-components';
import {
  SERVICE_PROVIDER_KYC_SUBJECT as SUBJECT,
  ServiceProviderKycIdvDialog,
} from './ServiceProviderKycIdvDialog';
import { KycIdvCardView } from './KycIdvCardView';

/** Profile entry point to the hosted IDV dialog, replacing the document upload. */
export const KycIdvCard: FC = () => {
  const { data: serviceProvider } = useGetServiceProviderPhoenix();
  const { openFor, openDialog, closeDialog, returnUrlFor } =
    useKycIdvDialogState<typeof SUBJECT>();

  const handleOpenDialog = useCallback(() => openDialog(SUBJECT), [openDialog]);

  return (
    <>
      <KycIdvCardView
        kycVerified={Boolean(serviceProvider?.data.mangopay_kyc_verified)}
        renewalDeadline={serviceProvider?.data.kyc_renewal_deadline ?? null}
        onOpenDialog={handleOpenDialog}
      />
      <ServiceProviderKycIdvDialog
        open={openFor === SUBJECT}
        onClose={closeDialog}
        returnUrl={returnUrlFor(SUBJECT)}
      />
    </>
  );
};
